import React from 'react';
import { Box, Typography, Divider, Chip, Button, Grid } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

function CertDetails({ certificate }) {
    if (!certificate) return null;

    const fullName = `${certificate.user?.firstName || ''} ${certificate.user?.lastName || ''}`.trim();
    const courseName = certificate.course?.title || 'Course';
    const issueDate = new Date(certificate.issuedAt).toLocaleDateString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const handleDownloadPDF = () => {
        const link = document.createElement('a');
        link.href = certificate.pdfUrl || certificate.imageUrl;
        link.download = `Certificate-${certificate.csnId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Box
            sx={{
                padding: { xs: '1.5rem', md: '2rem' },
                backgroundColor: '#fff',
                borderRadius: '16px',
                boxShadow: '0 6px 16px rgba(0,0,0,0.06)',
            }}
        >
            {/* Header and Download */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: 2,
                    mb: 2,
                }}
            >
                <Typography variant="h5" fontWeight={600}>
                    {courseName}
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<PictureAsPdfIcon />}
                    onClick={handleDownloadPDF}
                    sx={{ textTransform: 'none' }}
                >
                    Download Certificate
                </Button>
            </Box>

            {/* Certificate message */}
            <Typography variant="body1" mb={2}>
                This certificate was issued to <strong>{fullName}</strong>.
            </Typography>

            <Divider sx={{ mb: 3 }} />

            {/* Detail Grid Section */}
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        Issued On
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {issueDate}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        Expires On
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Never
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        Status
                    </Typography>
                    <Chip
                        label={certificate.status}
                        color="success"
                        size="small"
                        sx={{ fontWeight: 'bold', mt: 0.5 }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default CertDetails;
